import React from "react";

import {
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";


class PostSignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: RESOLVE_LOCAL_AUTH_STATE(),
      user: RESOLVE_LOCAL_USER_STATE(),
    };
  }

  componentDidMount() {
    // no-op for now
  }

  render() {
    const { user } = this.state;

    return (
      <div className="container signup-custom">
        <br /><br />
        <h1>Activate your account!</h1>
        <hr />
        <br /><br />
        <p>
          A confirmation email has been sent to <strong>{user.email}</strong>.
        </p>
        <p>Please check your email and activate your account!</p>
      </div>
    );
  }
}

export default PostSignUp;
